import React, { useState } from "react";
import { useAdminData } from "../../useAdminData";
import { Panel, Skeleton, EmptyState, fmtDate } from "../../Primitives";
import { Pagination } from "../Signals";
import { AUDIT_LABELS, ROLE_LABEL } from "./roles";

const detail = (r) => r.action === "role_changed" ? `${ROLE_LABEL[r.details?.from] || r.details?.from} → ${ROLE_LABEL[r.details?.to] || r.details?.to}`
  : r.details?.role ? ROLE_LABEL[r.details.role] : "";

export default function AuditLog({ refreshKey }) {
  const [page, setPage] = useState(1);
  const { data, loading } = useAdminData((a) => a.get("/admin/users/audit", { params: { page, page_size: 15 } }).then((r) => r.data), [page, refreshKey]);
  return (
    <Panel title="Registro de atividades" description="Ações administrativas e acessos ao painel." testid="audit-panel">
      {loading && !data ? <div className="p-4 space-y-2">{[0, 1, 2].map((i) => <Skeleton key={i} className="h-8" />)}</div>
        : !data?.rows.length ? <EmptyState title="Nenhuma atividade registrada" /> : (
          <>
            <div className="overflow-x-auto mia-scroll">
              <table className="ops-table ops-stack" data-testid="audit-table">
                <thead><tr><th>Quando</th><th>Ação</th><th>Por</th><th>Conta</th><th>Detalhe</th></tr></thead>
                <tbody>
                  {data.rows.map((r, i) => (
                    <tr key={`${r.at}-${i}`} className="mia-row">
                      <td className="mono text-[12px] text-[var(--muted)] whitespace-nowrap">{fmtDate(r.at)}</td>
                      <td>{AUDIT_LABELS[r.action] || r.action}</td>
                      <td className="text-[var(--muted)]">{r.actor_email || "—"}</td>
                      <td className="text-[var(--muted)]">{r.target_email || "—"}</td>
                      <td className="text-[12px] text-[var(--muted2)]">{detail(r) || "—"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <Pagination page={page} totalPages={Math.max(1, Math.ceil(data.total / data.page_size))} onPage={setPage} />
          </>
        )}
    </Panel>
  );
}
